export default "__VITE_ASSET__V9wPb2nF__"